const base = "volunteer_applications";

export const URLs = Object.freeze({
  list: base,
  retrieve: (id) => `${base}/${id}`,
  statuses: base + "/statuses",
  convert: (id) => `${URLs.retrieve(id)}/convert_to_registration`,
});
